// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import { RECENT_LOGS_FAILURE, RECENT_LOGS_REQUEST, RECENT_LOGS_SUCCESS } from "../constants/logs";
import { fetchLogsAction } from "./eventRequestDetails";

export const addLogAction = ({
    id,
    payload,
    successCallback
}) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'PUT',
            url: `addLog${id ? `/${id}` : ''}`,
            data: payload,
            isToken: true
        });

        if (response) {
            successCallback ?  successCallback() : null;
            dispatch(fetchLogsAction({eventId: id}))
        }
    }
};


export const addEditLogAction = ({
    id,
    payload,
    version,
    successCallback
}) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'PUT',
            url: `addEditLog${id ? `/${id}` : ''}`,
            data: payload,
            isToken: true
        });

        if (response) {
            successCallback ?  successCallback() : null;
            dispatch(fetchLogsAction({eventId: id}))
        }
    }
};


export const getAllLogsAction = ({
    successCallback
}) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'PUT',
            url: `getAllLogs`,
            data: null,
            isToken: true
        });

        if (response) {
            successCallback ?  successCallback() : null;
        }
    }
}


export const getLatestLogsOfUserAction = ({
    successCallback
}) => {
    return async (dispatch, getState) => {
        dispatch({
            type: RECENT_LOGS_REQUEST
        });

        const { response, error } = await apiRequest({
            method: 'GET',
            url: `getTenLatestLogs`,
            data: null,
            isToken: true
        });

        if (response) {
            dispatch({
                type: RECENT_LOGS_SUCCESS,
                payload: {
                    recentLogs: response?.data?.data
                }
            });
            successCallback ?  successCallback() : null;
        } else if (error) {
            dispatch({ type: RECENT_LOGS_FAILURE });
        }
    };
}